'use strict';
define('streamControl',['settings', 'errorHandler', 'translations', 'util'],
	function (settings, errorHandler, T, Util) {
		var iframePlayer,
			hlsPlayer,
			soundToggleButton,
			web = false,
			muted = true, // Muted by default
			game,
			prerecordedStream = false,
			streaming = false,
			waitingForResults = '',
			actionBeforeStream,
			actionAfterStream,
			playerLoaded = false;

		function streamPlayer() {
			return prerecordedStream ? hlsPlayer : iframePlayer;
		}

		function initSoundToggleButton(soundToggleButtonID) {
			soundToggleButton = document.createElement('img');
			soundToggleButton.id = soundToggleButtonID;
			soundToggleButton.addEventListener('click', function () {
				setMuted(!muted);
			});

			document.body.appendChild(soundToggleButton);

			updateVolumeIcon();
		}

		function setMuted(state) {
			muted = state;

			updateVolumeIcon();

			if (iframePlayer) {
				iframePlayer.setMuted(muted);
			}

			if (hlsPlayer) {
				hlsPlayer.setMuted(muted);
			}
		}

		function updateVolumeIcon() {
			if (soundToggleButton) {
				soundToggleButton.src = muted
					? 'images/volume-mute.svg'
					: 'images/volume-up.svg';
			}
		}

		function initStream(prerecorded, gameID, url, gameData) {
			return new Promise(function (resolve, reject) {
				var player;

				prerecordedStream = prerecorded;

				player = streamPlayer();
				if (Object.prototype.hasOwnProperty.call(player, 'init')) {
					player.init(gameID, url, muted, gameData)
						.then(() => {
							playerLoaded = true;
							resolve();
						})
						.catch((e) => {
							errorHandler.logError('ERROR', 'failed to initialize player', null,
								{
									problem: e,
									ua: navigator.userAgent,
									currentGame: gameID,
									streaming: streaming,
									url,
									muted
								});
							playerLoaded = false;
							resolve();
						});
				} else {
					resolve();
				}
			});
		}

		function showStream(url, currentGame, nextGameAction, gameNo) {
			var timeLeft = currentGame.gameEnd - Date.now(),
				player = streamPlayer();

			const duration = Util.videoStreamDurationLeft(currentGame);

			 // Prevent stream load if steam is already over or no player loaded
			if (duration < 0 || !playerLoaded) {
				nextGameAction(gameNo);
				stopPlaying();
				return;
			}

			if (!player) {
				return;
			}

			waitingForResults = currentGame.uuid;

			// Setup stream end action for every game
			setTimeout(function () {
				nextGameAction(gameNo);
			}, timeLeft);

			game = currentGame; // Streaming game

			if (streaming) {
				if (Object.prototype.hasOwnProperty.call(player, 'clearStream')) {
					player.clearStream()
						.then(function () {
							playStream(url);
						});
					return;
				}
			}

			streaming = true;
			playStream(url);

			if (duration) {
				setTimeout(function () {
					try {
						stopPlaying();
					} catch (e) {
						console.warn(e);
					}
				}, duration);
			}
		}

		function showPromotion(url) {
			if (!streaming) {
				streaming = true;
				playPromotion(url);
			}
		}

		function playStream(url) {
			var player = streamPlayer();

			if (!streaming) {
				return;
			}

			// Unmute stream on STBs
			if (!web) {
				setMuted(false);
			}

			player.play(url, muted, stopPlaying)
				.then(function () {
					errorHandler.stat.successfulStreams++;
					if (typeof actionBeforeStream === 'function') {
						actionBeforeStream();
					}
				})
				.catch(function (e) {
					if (game.gameStart - Date.now() <= 0) {
						errorHandler.stat.failedStreams++;
						errorHandler.showError(T.translate('translate_err4'), 5000);
						errorHandler.logError('ERROR', 'stream failed', null,
							{
								currentGame: game,
								streaming: streaming,
								problem: e,
								ua: navigator.userAgent
							});
					}
					setTimeout(playStream, 3000, url);
				});
		}

		function playPromotion(url) {
			// Unmute stream on STBs
			const promoMuted = web ? muted : false;

			hlsPlayer.init().then(function () {
				// HLS player is used for promotions
				hlsPlayer.play(url, promoMuted, function () {
					streaming = false;
					if (typeof actionAfterStream === 'function') {
						actionAfterStream();
					}
				})
					.then(function () {
						errorHandler.stat.successfulStreams++;
						if (typeof actionBeforeStream === 'function') {
							actionBeforeStream();
						}
					})
					.catch(function (e) {
						errorHandler.logError('ERROR', 'playing promotion video failed', null,
							{
								currentGame: game,
								streaming: streaming,
								problem: e,
								ua: navigator.userAgent
							});
						streaming = false;
						if (typeof actionAfterStream === 'function') {
							actionAfterStream();
						}
					});
			});
		}

		function stopPlaying() {
			var player = streamPlayer();

			if (!streaming || !player) {
				return;
			}

			streaming = false;

			if (typeof actionAfterStream === 'function') {
				actionAfterStream();

				if (typeof settings.local.promoVideoURL === 'string') {
					showPromotion(settings.local.promoVideoURL);
				}
			}

			// Mute stream on STBs
			if (!web) {
				setMuted(true);
			}

			try {
				player.clear();
			} catch (e) {
				console.warn('Error while trying to stop player: ' + e);
			}
		}

		function streamEnd(gameNo, callback, uuid) {
			if (waitingForResults === '') { waitingForResults = uuid; }
			getResult(uuid, gameNo)
				.then(function (resultAvailable) {
					if (!resultAvailable) {
						setTimeout(function () {
							streamEnd(gameNo, callback, uuid);
						}, 3000);
						return;
					}
					// Stop if latest stream ended
					if (waitingForResults === uuid) {
						callback(settings.games[gameNo], gameNo);
						waitingForResults = '';
						// stopPlaying();
					}
				})
				.fail(function () {
					if (uuid === waitingForResults) {
						setTimeout(function () {
							streamEnd(gameNo, callback, uuid);
						}, 3000);
					}
				});
		}

		function getResult(uuid, gameNo) {
			var gameConfig = settings.games[gameNo].config[settings.games[gameNo].module],
				url = gameConfig.baseUrl + '/instance/' + uuid;

			return $.ajax({
				url: url,
				method: 'GET',
				dataType: 'json'
			})
				.then(function (data) {
					return !!(data.result || data.cancelled);
				})
				.fail(function (err) {
					errorHandler.logError('ERROR', 'error while getting result', err, {
						url: url
					});
					errorHandler.showError(T.translate('translate_err7'), 3000);
				});
		}

		function setIframePlayer(pl) {
			iframePlayer = pl;
		}

		function setHLSPlayer(pl) {
			hlsPlayer = pl;
		}

		function setWeb(isWeb) {
			web = isWeb;
		}

		function setScreenActions(beforeStream, afterStream) {
			actionBeforeStream = beforeStream;
			actionAfterStream = afterStream;
		}

		return {
			initStream: initStream,
			initSoundToggleButton: initSoundToggleButton,
			showStream: showStream,
			showPromotion: showPromotion,
			streamEnd: streamEnd,
			setIframePlayer: setIframePlayer,
			setHLSPlayer: setHLSPlayer,
			setWeb: setWeb,
			setScreenActions: setScreenActions
		};
	});

